import agreement1 from '@/locales/Terms/FranchiseAgreement/JP/agreement1.html';
import agreement2 from '@/locales/Terms/FranchiseAgreement/JP/agreement2.html';
import agreement3 from '@/locales/Terms/FranchiseAgreement/JP/agreement3.html';
import agreement4 from '@/locales/Terms/FranchiseAgreement/JP/agreement4.html';
import agreement5 from '@/locales/Terms/FranchiseAgreement/JP/agreement5.html';
import agreement6 from '@/locales/Terms/FranchiseAgreement/JP/agreement6.html';
import agreement7 from '@/locales/Terms/FranchiseAgreement/JP/agreement7.html';
import agreement8 from '@/locales/Terms/FranchiseAgreement/JP/agreement8.html';
import agreement9 from '@/locales/Terms/FranchiseAgreement/JP/agreement9.html';
import agreement10 from '@/locales/Terms/FranchiseAgreement/JP/agreement10.html';
import agreement11 from '@/locales/Terms/FranchiseAgreement/JP/agreement11.html';
import agreement12 from '@/locales/Terms/FranchiseAgreement/JP/agreement12.html';
import agreement13 from '@/locales/Terms/FranchiseAgreement/JP/agreement13.html';
import guideline1 from '@/locales/Terms/Guideline/JP/guideline1.html';
import guideline2 from '@/locales/Terms/Guideline/JP/guideline2.html';
import legal_indication1 from '@/locales/Terms/LegalIndication/JP/legal_indication1.html';
import legal_indication2 from '@/locales/Terms/LegalIndication/JP/legal_indication2.html';
import legal_indication3 from '@/locales/Terms/LegalIndication/JP/legal_indication3.html';
import legal_indication4 from '@/locales/Terms/LegalIndication/JP/legal_indication4.html';
import legal_indication5 from '@/locales/Terms/LegalIndication/JP/legal_indication5.html';
import legal_indication6 from '@/locales/Terms/LegalIndication/JP/legal_indication6.html';
import legal_indication7 from '@/locales/Terms/LegalIndication/JP/legal_indication7.html';
import legal_indication8 from '@/locales/Terms/LegalIndication/JP/legal_indication8.html';
import privacy_policy1 from '@/locales/Terms/PrivacyPolicy/JP/privacy_policy1.html';
import privacy_policy2 from '@/locales/Terms/PrivacyPolicy/JP/privacy_policy2.html';
import privacy_policy3 from '@/locales/Terms/PrivacyPolicy/JP/privacy_policy3.html';
export default {
	locale_order: 1,
	locale_name: '日本語',
	terms: {
		title: 'ONETETHERサービス利用約款',
		agreement1,
		agreement2,
		agreement3,
		agreement4,
		agreement5,
		agreement6,
		agreement7,
		agreement8,
		agreement9,
		agreement10,
		agreement11,
		agreement12,
		agreement13,
		guideline1,
		guideline2,
		legal_indication1,
		legal_indication2,
		legal_indication3,
		legal_indication4,
		legal_indication5,
		legal_indication6,
		legal_indication7,
		legal_indication8,
		privacy_policy1,
		privacy_policy2,
		privacy_policy3,
		menu: {
			category1: '加盟店規約',
			title1: '加盟店約款(オンライン決済用)',
			title2: 'オンライン決済に関するAPI利用特約',
			title3: '残高加盟店規約 (オンライン決済用)',
			title4: 'クレジットカード加盟店約款',
			title5: 'ONETETHER for Business利用規約（オンライン決済用）',
			title6: 'あと払い加盟店約款（オンライン決済用）',
			title7: 'データ利用特約',
			title8: '商品等代金の支払いに関する特約',
			title9: '前払いサービスの取扱いに関する特約',
			title10: '加盟店規約（ミニアプリ⽤）',
			title11: 'データ利用特約（ミニアプリ用）',
			title12: '契約の成立_プライバシーポリシー',
			title13: '加盟店情報の共同利用について',
			category2: 'ガイドライン',
			title14: 'ONETETHER加盟店ガイドライン（ミニアプリ用）',
			title15: '加盟店ガイドライン（オンライン決済用）',
			category3: '法令上の表示',
			title16: '銀行代理業概要',
			title17: '取扱商品カードローン個人金利等',
			title18: '取扱商品カードローン個人商品概要',
			title19: '円普通預金口座金利等',
			title20: '円普通預金口座商品概要',
			title21: '取扱商品ビジネスローン金利等',
			title22: '取扱商品ビジネスローン商品概要',
			title23: '当社ローンを複数ご契約の場合の適用金利について',
			category4: 'プライバシーポリシー',
			title24: '個人情報公開請求',
			title25: 'ユーザーセキュリティについて',
			title26: '関係会社',
		},
	},
	cookies: {
		title: 'クッキー(Cookies) 利用方針',
		text1:
			'ONETETHERは出所及びその他統計資料を得るため、ウェブサイト利用者の検索情報を匿名で収集するにあたって クッキー(Cookie)を使用します。',
		text2:
			'クッキー(Cookie)とは、例として商品購入過程、検索傾向及び活動等を記録する為のウェブサイトのとても小さいテキストファイルで、貴下のパソコンハードウェアに保存されます。',
		text3: '特に次の様に使用されます:',
		text4:
			'Google Analytics. グーグルは自社のサービス改善と他社へサービスを提供するためにこの情報を利用できます。',
		text5: '次のリンクを通じて全ての情報に接近することができます。',
		text6: 'データ保護',
		text7: 'アナリティクスブロックブラウザ付加機能',
		text8:
			'上の道具は利用者の名前、住所及び接続情報を収集しません。収集される利用者の情報には、例えば接続サイト数、使用言語、利用者IPが表示する都市、訪問者数、再訪問数、接続時間、使用するブラウザー、運営者又はターミナル類型等と関連があります。上の情報は新しい要求事項を把握し改善努力に対する評価を通じて利用者達へよりよいウェブサイトのサービスを提供するために使用されます。',
		text9:
			'ソーシャルネットワークで使用するクッキー(Cookie). このウェブサイトでは使用者の関心コンテンツをグループと共有できるようにソーシャルネットワークボタンが設置されています。ソーシャルネットワークを通じて保存されたクッキー(Cookie)は上のコンテンツ共有にあたって個人情報再入力の不便を防止します。',
		text10:
			'利用者はパソコンに設置されているウェブブラウザーの道具オプションを通じて全てのクッキー(Cookies)を許容/拒否するか、削除またはクッキーが保存される度に確認をするようにすることができます。',
		text11:
			'下のリンクで使用する各ウェブブラウザーによる機能情報を見ることができます：',
		text12: 'ファイアフォックス',
		text13: 'クロム',
		text14: 'サファリ',
	},
	rtr_home: {
		text1: '未だに暗号資産で',
		text2: '決済ができないと',
		text3: '思いますか？',
		text4: '暗号資産を両替せずに今すぐ決済が可能です。',
		button1: '暗号資産で即時決済',
		text5: 'ONETETHER',
		text6: '安全性とスピードを同時に',
		text7: 'ブロックチェーンの安全性とONETETHERだけの技術力で、',
		text8: '最も迅速な決済システムをご体験ください。',
		text9: '会員登録',
		text10: '私たちは',
		text11: '無料で提供しています。',
		text12: '最高の技術と最高のサービスを体験できる',
		text13: 'プラットフォームを無料で利用できます。',
		text14: '無料アカウントの作成',
		text15: 'ONETETHER',
		text16: '多くのメリット',
		text17: 'ONETETHERはカードが必要ありません。',
		text18: 'ネットワークさえつながっていれば、どこでも',
		text19: 'ONETETHERにアクセスしてお支払いができます。',
		text20: 'さらにQRコード決済も可能です。',
		text21: 'オフラインではキオスクやPOSレジで ',
		text21_1: 'スキャンしてもらうだけでお支払いができます。',
		text22: 'ショッピングと購入方法',
		text23: 'ONETETHER決済',
		text24: 'どこでも決済可能',
		text25: 'QRコード決済',
		text26: 'QRコードで簡単に決済',
		text27: 'キオスクやPOSレジ',
		text28: 'オフラインで簡単に決済',
		text29: '世界中どこでもご利用できます。',
		text30: '誰でも、どこでも使用できる',
		text31: '暗号資産の最大の魅力をONETETHERは知っています。',
		text32:
			'私たちは、世界中で暗号資産の使い方を教えてくれるアシスタントになりたいです。',
		button2: '無料で始める',
		text33: 'ビジネス会員でも',
		text34: '無料でご利用できます。',
		text35: 'ビジネスを拡大するための方法をお探しですか。',
		text36: 'まだ通貨ペアだけで決済していますか。',
		text37: '全世界で使われている暗号資産で決済をお試しください。',
		text38: 'ビジネスショップ開設',
		text39: '私たちは',
		text40: 'あなたの声に耳を傾けます。',
		text41: 'ONETETHERは、常にお客様の声を聞いて、',
		text42: '実践していきます。',
		text43: 'お問い合わせ',
	},
	'rtr_personal-how-online_shopping': {
		title1: 'ONETETHERで決済する',
		text1: 'お好みの暗号資産を追加して、好きな場所で',
		text2: '柔軟なショッピングを体験してください。',
		text3: '電子マネーにだけある暗号資産を、',
		text4: 'ONETETHER',
		text5: 'を通じて',
		text6: 'どこでも買い物を楽しめます。',
		text7: 'ONETETHERでお好きな',
		text8: '暗号資産のウォレットを作ってください。',
		text9: 'ショッピングのお支払いの際に',
		text10: 'ONETETHERをお選びください。',
		text11: 'ONETETHERを使い、',
		text12: 'お好きな暗号資産でお支払いください。',
		title2: '繰り返し',
		title3: 'お楽しみください。',
		text13: 'ONETETHERで商品を購入してポイントをもらい',
		text14: 'そのポイントを使ってまた商品をご購入ください。',
		text15: 'ONETETHERポイントは、',
		text16: 'ONETETHERを使用するすべての加盟店で使用できます。',
		title4: '安心して',
		title5: 'ご利用してください。',
		text17: 'ONETETHERのセキュリティは世界最高を誇ります。',
		text18: 'お客様の個人情報や暗号資産を安全に守り、',
		text19: '安心して使用できるようにします。',
	},
	'rtr_personal-how-offline_kiosk': {
		title1: 'オフライン加盟店での',
		title2: 'ご利用方法',
		text1: 'スピーディーに決済ができます。',
		text2: '現金やクレジットカードがなくてもスマホさえあれば',
		text3: '簡単に支払いができるONETETHERをご利用ください。',
		text4: 'ONETETHER',
		text5: 'を利用した決済方法',
		text6: 'スマホでONETETHERを',
		text7: '選択して実行してください。',
		text8: 'お財布をタップして',
		text9: '「オフラインショップ決済」を選択してください。',
		text10: 'QRコードをPOSレジに',
		text11: 'スキャンすれば決済完了です。',
		text12: '未来の貨幣システム',
		text13: 'へようこそ。',
		text14: '安全な決済',
		text15: 'オフライン決済時にお客様のデータは残りません。',
		text16: 'お近くの加盟店で',
		text17: 'いつでも、どこでも、ONETETHER加盟店を検索してご利用ください。',
		text18: 'キャッシュレス',
		text19:
			'まだ現金を持ち歩きますか?スマホでONETETHERをすぐ使うことができます。',
		title3: '販売加盟店の方も',
		title4: '簡単にアクセスできます。',
		text20: 'ONETETHERキオスクに販売物品を登録するだけで完了です。',
		text21: '支払いはONETETHERキオスクが行います。',
	},
	'rtr_personal-how-qr': {
		title1: 'ONETETHERを使って、',
		title2: '良く行くお店でお支払いしてください。',
		text1: '対面での決済は、お支払い時にQRコードを',
		text2: 'スキャンするのと同じくらい簡単で、タッチが不要です。',
		text3: 'クレジットカードや現金は不要で、アプリを使うだけです。',
		text4: '未来の貨幣システムへようこそ。',
		text5: '安全な決済',
		text6: 'ONETETHERはQRコード取引中に',
		text7: '自分の情報を公開しません。',
		text8: '全ての加盟店で',
		text9: 'どの加盟店でも24時間いつでも',
		text10: 'オフライン加盟店で',
		text11: 'お支払いいただけます。',
		text12: 'タッチ不要、キャッシュレス',
		text13: '現金やクレジットカードは不要です。',
		text14: 'アプリを開いてお支払いください。',
		text15: 'QRで3段階決済',
		text16: 'ONETETHER',
		text17: 'アプリとアカウントが必要です。',
		text18: 'STEP 01. スキャンもしくは表示',
		text19: 'STEP 02. 支払い',
		text20: 'STEP 03. 確認',
		text21: 'QRアイコンをタップして、販売加盟店がコードを提示した場合は',
		text22: 'スキャンを選択する。またはQRコードを要求された場合は',
		text23: '「表示」を選択します。',
		text24: 'QRコードが表示されたらコードをスキャン',
		text25: '決済確認を受信するとすべての決済が完了します。',
		title3: 'QRコードで',
		title4: '販売する準備をしましょう。',
		text26: 'ビジネスを開始する場合、ハードウェア、ソフトウェア、',
		text27: 'またはカードリーダーが無くても直接タッチする必要が無いので、',
		text28: '対面決済を簡単に受け入れることができます。',
		text29: 'STEP 01.',
		text30: 'スキャンもしくは表示',
		text31: 'STEP 02.',
		text32: '支払い',
		text33: 'STEP 03.',
		text34: '確認',
	},
	'rtr_personal-how-janopay_creditcard': {
		title1: 'ONETETHERカード',
		text1: 'デビットカードとプリペイドカードでONETETHERにアクセスしたり、',
		text2: 'クレジット利用で日常的な購入に簡単に資金を',
		text3: '調達できます。',
		title2: 'ONETETHER·クレジット',
		title3: 'その場で商品を購入して、時間の経過とともにお支払い。',
		text4: 'ONETETHERを利用できる全ての加盟店で',
		text5: '1万円以上購入するとき、特別金融を受けてください。',
		text6: '1万円相当の商品を購入する度に6ヶ月以内に',
		text7: '全額を支払う場合は利息はありません。',
		text8: '6ヶ月以内に残金を支払わない場合は、',
		text9: '購入日から利息がお客様のアカウントに請求されます。',
		text10: '最低月額支払いが必要となります。クレジット承認の対象です。',
		text11: 'ショッピング及び購入方法',
		text12: 'ONETETHER加盟店の',
		text13: '全てのお店で利用可能。',
		text14: '年会費なし',
		text15: 'ONETETHERアカウントから',
		text16: 'ONETETHERコインアクセス',
		title4: 'NEW',
		title5: 'ONETETHERキャッシュバック(JPYSコイン)',
		text17: 'ONETETHER購入時に無制限の3%キャッシュバック、',
		text18: '他の全て商品の購入時に無制限の2%を獲得します。',
		text19: 'いつ使用できるかを最初に確認してください。',
		text20:
			'既に2%キャッシュバックを受け取った方はリストに登録する必要ありません。',
		text21: '自動的にアップグレードされます。',
		title6: 'ONETETHER キャッシュカード',
		text22: 'ONETETHER残高につながれているデビットカードで',
		text23: '資金にアクセスして',
		text24: '資金を簡単に管理することができます。',
		text25: 'ONETETHERキャッシュカードの詳細',
		text26: 'ONETETHERクレジットについて学ぶ',
		text27: '利用規約を見る',
	},
	'rtr_personal-how-trade_and_cashback': {
		title1: 'ONETETHERを使うことで',
		title2: '様々な特典が得られます。',
		text1: '取引、キャッシュバックの提案やプロモーションコードを積み重ねて、',
		text2: 'お金を節約し、お気に入りのお店やブランドから',
		text3: '報酬を獲得しましょう。',
		title3: '自分好みの暗号資産での取引',
		text4: 'ONETETHERはあなたが購入商品や購入場所に基づいて、',
		text5: 'あなたが気に入ると思われる取引、製品及びお店をご紹介します。',
		text6: '気に入るお店も増やし続け、アップデートすることを約束します。',
		title4: 'Maximize your rewards',
		title5: 'より多くの報酬を提供します。',
		text7:
			'取引、キャッシュバック提案の及びプロモーションコードを組み合わせると、',
		text8: 'より多くの費用を節約できます。',
		text9: 'お支払い時にプロモーションコードを調べて適用する',
		text10: 'お手伝をします。',
		text11: 'ONETETHERカードは報酬を提供しますか?',
		text12:
			'ご購入についてチェックアウトし、報酬を受け取るときにご利用頂けます。',
		text13: 'ショッピングを始める',
		title6: 'セキュリティのチェックアウト',
		text14: 'ONETETHERで安全に決済する際は、数百万個の',
		text15:
			'グローバル小売業者からの取引及びキャッシュバック提案をご活用頂けます。',
		text16: 'あなたの個人情報は暗号化されており、',
		text17: '貴下の許諾がなければ販売または共有は一切致しません。',
		text18: 'あなたを守る方法の詳細を知る',
	},
	'rtr_personal-request-send': {
		title1: 'オンラインで送金する',
		title2: '安全で面白い方法',
		text1: '世界中のほぼすべての場所で家族や友だちに素',
		text2: '早く送金できる簡単な方法です。',
		text3: 'すべての転送を最大限に活用',
		text4: '双方向のメッセージ',
		text5: '友達間の支払いが正しいかどう',
		text6: 'かを再確認するために',
		text7: 'メッセージを交換してください。',
		text8: '無料オプション',
		text9: 'ONETETHERポイントカードを使用して、',
		text10: 'ONETETHERの残高を確認した後、海外から',
		text11: 'オンラインで送金することができます。',
		text12: '迅速なアクセス',
		text13: '暗号資産を送金する際、',
		text14: '受信者は待たずにす',
		text15: 'ぐ受け取ることができます',
		title4: '年中無休モニタリング',
		text16: '暗号化技術により、ONETETHERはあなたの送金が安全であること',
		text17: 'を確認するために最善を尽くします。',
		title5: '全世界へ送金',
		text18: 'ONETETHERサービスを利用して、',
		text19: '世界中のどこにでも送金してください。',
		text20: '全世界中どこでも友達や家族にオンラインで送金',
		text21: '0 JPYS',
		text22: 'JPYS内取引手数料無料',
		text23: '他行財布出金時に',
		text24: 'ONETETHER残高からお金を送るとき 0%',
	},
	'rtr_personal-request-receive': {
		title1: 'シンプルな要請',
		text1: '友達と家族に通知なしで',
		text2: '暗号資産を要請することができます',
		title2: '快適な資産要請サービス',
		text3: '快適で使いやすく手軽にできる、',
		text4: '双方向の要請メッセージサービス',
		title3: '手軽な',
		title4: '無料要請サービス',
		text5: '友人に簡単に送金を要請して待つと',
		text6: '自動的に入金されます。',
		title5: 'シンプルな設定',
		text7: '友人がONETETHERアカウントをお持ちではなくても、',
		text8: '数分で会員登録するだけ完了です。',
		text9: '給与を支給することも簡単にできます。',
		text10: 'アプリを開き、支払い受け取るを選択してください。',
		title6: 'ONETETHERでユーザーを選択して',
		title7: '要請金額を入力してください。',
		title8: 'セキュリティのチェックアウト',
		text11: '即座にONETETHER資産要請リンクを作って、',
		text12: '毎日でも暗号資産を受け取る事が容易になります。',
		text13: 'ONETETHERリンクの作成',
	},
	'rtr_personal-request-deposit': {
		text1: '入金受け取り',
		text2: 'ONETETHERで便利に入金を受け取ってください。',
		text3: '最も便利な送金',
		text4: '相手のEメールに送信して完了',
		text5: '受領者側に表示されること',
		text6: 'ONETETHERと',
		text7: 'ONETETHER間の送金',
		text8: 'ONETETHERからONETETHERへ送金時',
		text9: '使用される口座番号が露出されます。',
		text10: '外部から',
		text11: 'ONETETHERに入金',
		text12: '外部からONETETHERに入金時',
		text13: '使用されるウォレット住所が露出されます。',
	},
	'rtr_personal-request-commission': {
		text1: '送金手数料無料',
		text2: 'ONETETHER間の送金時手数料無料!',
		text3: '外部ウォレット入金時',
		text4: 'ネットワーク費用のみ',
		text5: '入金時ONETETHERでは',
		text6: '手数料支払い要請を致しません。',
		text7: '自社のプラットフォーム内の',
		text8: '移動は無料です。',
		text9: '外部出金時のみ手数料発生',
		text10: 'ONETETHERを利用性手購入時手数料無料',
	},
	'rtr_personal-asset-wallet': {
		text1: '国際規格ウォレット使用',
		text2: 'セキュリティにセキュリティをかけた独自ウォレット',
		text3: '外部ウォレット業者じゃなく独自開発ウォレット',
		text4: '国際規格に合わせた',
		text5: 'LEVEL 2 以上のセキュリティ',
		text6: 'もう一度のセキュリティを施し',
		text7: 'ハッキングを完璧に防ぎます。',
		text8: '個人キーが',
		text9: '発生しません。',
		text10: '管理者及びDBハッキングが入っても',
		text11: '個人キーが無くハッキングが難しいです。',
		text12: 'ウォレットとは',
		text13: 'お客様の金庫同様です。',
		text14: '私たちONETETHERは独自ウォレットを制作後、',
		text15: 'セキュリティにセキュリティを重ねたウォレットの為ハッキング対応に',
		text16: '最適化されていてセキュリティに関しては自信をもっています。',
	},
	'rtr_personal-asset-account': {
		text1: 'ONETETHER 独自口座システム',
		text2: '銀行にのみ口座があるのではありません。',
		text3: 'ONETETHER 提供口座で、より便利に',
		text4: '独自口座システムで',
		text5: 'より早く',
		text6: 'ONETETHERからONETETHER口座に送金時',
		text7: '1~3秒内に送金が可能になりました。',
		text8: 'もう待つ必要がありません。',
		text9: '送金システムを作る',
		text10: '口座を利用したONETETHERからONETETHERに送金時',
		text11: '手数料無料、時間短縮が可能',
		text12: 'ONETETHER 口座システムで早い送金',
		text13: '今体験してみてください。',
	},
	'rtr_personal-asset-jpys': {
		text1: 'JPYS独自ポイントシステム',
		text2: '速くて安全な独自ポイントシステム',
		text3: '固定された為替提供で心配がない。',
		text4: '全てのシステムと連動',
		text5: 'オフラインショップ及びオンラインストアも',
		text6: '全てJPYSさえあれば対応できます。',
		text7: 'キオスク及びPOSレジ どこでも',
		text8: '決済を自由に',
		text9: '便利なチャージ',
		text10: 'ご希望の暗号資産及びクレジットカードで',
		text11: 'クイックチャージが可能です。',
	},
	'rtr_personal-asset-sale': {
		title1: '売却する',
		text1: '暗号資産売却が難しいですか？',
		text2: 'まだ購入者をお待ちですか？',
		title2: '暗号資産売却がとて',
		title3: 'も簡易になりました。',
		text3: 'お客様間の売却',
		text4: 'お客様が直接ONETETHERで販売',
		text5: 'お好きな方法で売却してください。',
		title4: 'ボタン一度で',
		title5: '為替が自動適用',
		text6: 'ボタン一度で現在レートが',
		text7: '自動で適用されすぐに売却が可能です。',
	},
	'rtr_personal-asset-exchange': {
		title1: '銀行の様な両替',
		text1: '販売したり購入したり',
		text2: '今でも両替するためにあっちこっちに行かれてますか？',
		title2: '両替してすぐ送金及び出金',
		text3: '暗号資産の購入と送金が難しいですか？',
		text4: '銀行の様にお使い頂けます。すぐに送金及び出金が可能です。',
		title3: 'ボタン一度で',
		title4: '簡単に両替ができます。',
		text5: '自動為替、自動売却',
		text6: 'とても簡単なインターフェース',
		title5: '希望の資産をいつでも',
		text7: '暗号資産と暗号資産間の両替も可能',
		text8: '暗号資産をJPYSポイントで両替も可能',
	},
	'rtr_business-how-start': {
		title1: '始めましょう',
		text1: 'すべてはビジネスアカウントから始まります。',
		text2: 'ONETETHERを利用する3,000万人以上の販売者と一緒に。',
		text3: '始めるためにアカウントの専門家にお問い合わせてください',
		title2: 'シンプルな設定',
		text4: 'お問い合わせください。',
		text5: 'お手伝い致します。',
		// text6: 'help@janopay.com',
		title3: '参加は無料です。',
		text7: 'メールアドレスとビジネスに',
		text8: '関するいくつかの基本的な情報をご用意ください。',
		text9: 'ビジネスアカウントに登録',
		title4: 'サービス開始',
		text10: 'メールアドレスと会社名を確認して、',
		text11: 'ONETETHERアカウントを接続すると、',
		text12: '最初の販売準備が完了します。',
	},
	'rtr_business-how-receive': {
		title1: 'オンラインおよび',
		title2: '対面決済の承諾',
		title3: '競争優位を確保',
		title4: 'お客様が求める柔軟性',
		title5: '世界中の購買者と繋がります。',
		title6: 'オンライン決済の承諾',
		title7: 'オンラインチェックアウト',
		title8: '請求書と見積もり',
		title9: 'ソーシャルでの販売',
		title10: 'オンライン暗号資産決済システム',
		title11: '対面での決済の承諾',
		title12: '販売ポイント',
		text1: '始めるためにアカウントの専門家にお問い合わせてください',
		text2:
			'私たちは、小企業がどんな状況でも支払いを受けることをお手伝い致します。',
		text3: 'お客様が後払いをされるか、定期購入に登録するか、',
		text4: 'グローバルまたはローカルの決済オプションをご利用ください。',
		text5: 'すべての暗号資産を使って、オンラインまたは店舗で',
		text6: '支払いを受け入れます。',
		text7: 'お客様がお好みの方法でお支払いいただき、',
		text8: '素早く決済ができるようにします。',
		text9: 'こちら',
		text10: 'からオンライン',
		text11: '決済を承諾する方法の詳細をご覧ください。',
		text12:
			'お客様は単一ソリューションでサイト、モバイル、またはアプリで様々な決済手段が',
		text13: 'ご利用できます。',
		text14: 'オンラインチェックアウトの詳細',
		text15: 'サブスクリプションサービスの詳細',
		text16:
			'お客様が簡単に支払うことのできるカスタマイズされた無料の請求書を送ることによって、',
		text17: '支払いを促すことができます。',
		text18: '請求書発行に関する詳細',
		text19:
			'色んなソーシャルメディアプラットフォームで、ONETETHER決済システムを使用して',
		text20: '支払いを受け取ることができます。',
		text21: 'ソーシャルでの販売の詳細',
		text22: 'ONETETHERのクレジット及びオンライン決済サービスにより、',
		text23:
			'主要な暗号資産でのオンライン及び店舗内の支払いを受け入れることができます。',
		text24: 'お客様が直接買い物中に費用を支払うことができます。',
		text25: 'ここ',
		text26: 'での仕組みを学びます。',
		text27: 'すべての人気のある決済タイプを受け入れ、販売を追跡し、',
		text28:
			'完全なPOSソリューションであるONETETHER Settingでビジネスを管理しましょう。',
		text29: 'ONETETHER Settingの詳細',
	},
	'rtr_business-how-pay': {
		title1: 'ビジネス決済と資金アクセス',
		title2: '便利にお買い求めください',
		title3: 'お支払いのみの場合',
		title4: 'お支払い',
		title5: '今日、始める',
		text1: 'ONETETHERと一緒なら手軽な送金、支出、移動時の',
		text2: 'ビジネス取引が可能です。',
		text3:
			'あなたのビジネスに高度にカスタマイズ可能な商取引ソリューションが必要ですか？',
		text4: '企業向けのONETETHERについて学ぶ。',
		text5: 'ONETETHERの残高を使',
		text6: 'ってオンラインおよびビジネス費用を直接お支払いください',
		text7: '資金を電子的に送信して時間と労力を節約しましょう。',
		text8: '送金方法を学ぶ',
		text9: '同時に複数の人と場所へ簡単に送金することができます',
		text10: '販売代金の詳細',
		text11: 'ONETETHERを使っている販売者と一緒に。',
		text12: 'ビジネスアカウントの登録',
		text13:
			'1. ONETETHERでお金を管理して使うためには、ONETETHERビジネスアカウントまたはONETETHER残高アカウントが必要です。',
		text14:
			'2. ONETETHER Business Debit BlockChainを購入する際にボーナスキャッシュバックを受け取ることができる取引は次の通りです。(1)あなたが署名し、ブロックチェーンカードが処理するクレジット取引、(2)キャッシュバックの提案を受けることができない取引の現金の引き出し、(3)現金サービスで処理される取引またはPINを使用した取引',
		text15:
			'ONETETHER Business Debit BlockChainは、ONETETHERから発行します。カードはBlockChainが、ONETETHERが通用するすべてのことろでご利用いただけます。ONETETHERはカード発行者であり、ONETETHER関連のアカウントやその他の製品、サービスまたは提案について責任を負いかねます。',
	},
	'rtr_business-how-risk': {
		title1: 'お客様の気持ちや',
		title2: '消費者の為のもの',
		title3: '豊かな経験',
		title4: '安全な取引',
		title5: '詐欺探知技術',
		text1: '機械学習を通じてビジネスを守り、',
		text2: 'お客様の資産と共に消費者の事をお守りする事が出来ます。',
		text3:
			'あなたのビジネスに高度にカスタマイズ可能な商取引ソリューションが必要ですか？',
		text4: '企業向けのONETETHERについて学ぶ。',
		text5:
			'ブロックチェーンが知られるようになり始めてから積み重ねたブロックチェーン',
		text6:
			'ノウハウを基に作られたONETETHERを通じて安全な取引をご利用ください。',
		text7: '世界で最も安全なブロックチェーンに基づいて、',
		text8: '世界中の顧客に近づくことができます。',
		text9: '当社の詐欺探知ツールは、取引があるたびにより知能化し、',
		text10: '既存の脅威だけではなく進化する脅威までもあなたをお守り致します。',
	},
	'rtr_business-operation-corps': {
		title1: '기업에 관해',
		text1: '보안과 관리는 저희가 합니다.',
		text2: '운영에만 신경 쓰시면 됩니다.',
		title2: '가맹점 관리도 자동으로',
		text3: '아직도 일일이 관리를 하고 계신가요?',
		text4: '자노페이만 사용하면 자동으로',
		title3: '회원가입하고 가맹점 등록 끝',
		text5: '가맹점 관리 프로그램 무료.',
		text6: '사용료 없이 평생 무료 사용.',
	},
	'rtr_business-operation-platform': {
		title1: '플랫폼 및 기능',
		text1: '기업관리에 최적화.',
		text2: '오로지 기업에 맞추어져 있습니다.',
		title2: '가맹점 관리에서부터',
		title3: '정확한 정산까지',
		text3: '기업에 최적화된 플랫폼을 만나보세요.',
		title4: '직관적이고 심플합니다.',
		text4: '기업에 관해서는 최대한 심플하게',
		title5: '배우지 않아도',
		title6: '바로 사용 가능하게',
		text5: '플랫폼과 기능을 최대한 심플하게.',
		text6: '그래서 관리자가 쉽게 사용 가능합니다.',
	},
	'rtr_business-operation-pay': {
		title1: '지불 방법',
		text1: '고객은 휴대폰 하나로 가맹점에 지불 가능.',
		title2: '가맹점에 지불된',
		title3: '자노페이는',
		text2: '가맹점별로 정산 또는 전체 가맹점 정산',
		title4: '정산된 자노페이는 고정되어',
		title5: '언제든지 출금 가능합니다.',
	},
	'rtr_business-operation-global': {
		title1: '글로벌 결제 처리',
		text1: '자노페이를 받아서 원하는 나라에 맞게 출금 가능.',
		title2: '현재 환율에 자동 적용',
		text2: '언제든지 원하는 시간에 출금.',
		title3: '자노페이 고객은 나라에',
		title4: '상관없이 결제 가능합니다.',
		title5: '암호화폐를 사용하는 이유',
		text3: '가장 좋은 이유는 환율의 개수만 보면 되기 때문입니다.',
	},
	'rtr_business-asset-pay': {
		title1: '자노페이 가맹점 등록',
		text1: '고객이 지불한 페이는 등록된 가맹점 별로 정산',
		title2: '가맹점이 많아도',
		title3: '한번에 전체 정산',
		text2: '품목별까지 꼼꼼하게 놓치지 않고 정산됩니다.',
		title4: '언제든지',
		title5: '원하는 방식으로 지불',
		text3: '암호화폐로 지불할 수 있고',
		text4: '원하는 통화쌍으로 지불이 가능합니다.',
	},
	cs: {
		title: 'カスタマーセンター',
		notice: '公知事項',
		inquiry: {
			inquiry: '1:1お問い合わせ',
			list: '問い合わせ内訳',
			type: '問合せタイプ',
			title: 'タイトル',
			date: '登録日',
			status: '状態',
			pending: '待機',
			complete: '完了',
			no_content: '登録された内容がありません。',
			text1: 'お問い合わせの作成内容が',
			text2: '正常に受付完了',
			text3: 'しました。',
		},
		faq: 'よく聞かれる質問',
		ticket: {
			id: 'Ticket ID',
			text1: 'お問い合わせに対する回答を確認する際に必要なIDです。',
			text2: 'お問い合わせ内容を確認するため、PINコードを入力してください。',
			text3: 'お問い合わせ内容を確認',
			text4: 'お問い合わせの際に発行していただいたTicketIDと',
			text5: 'パスワードを入力してください。',
			input1: 'TicketIDを入力してください。',
			input2: 'パスワードを入力してください。',
		},
		placeholder: {
			type: 'お問い合わせのタイプを選択してください。',
			title: 'タイトルを入力してください。',
			content: 'お問い合わせ内容を入力してください。',
		},
	},
	'rtr_auth-login': {
		text1: 'IDまたはパスワードを忘れた場合',
	},
	'rtr_auth-find-account': {
		text1: 'IDをお忘れの方',
		text2: 'パスワードをお忘れの方',
		text3:
			'ジャノペイにご加入時、ご入力したEメールアドレスからお調べ頂けます。',
		text4:
			'ジャノペイにご加入時、ご入力したIDとEメールアドレスからお調べ頂けます。',
		text5: 'パスワードを変更してください。',
		placeholder1: 'メールアドレスを入力してください。',
		placeholder2: 'IDを入力してください。',
		placeholder3: '認証番号を入力してください。',
		placeholder4: '新しいパスワードを入力してください。',
		placeholder5: '新しいパスワードの確認を入力してください。',
	},
	'rtr_auth-register': {
		text1: '毎日多くの人々が利用する',
		text2: 'ONETETHERと共にありましょう。',
		text3: '会員登録を開始します。',
		text4: 'サービス利用規約に同意してください。',
		text5:
			'全ての同意項目は必須及び選択項目に対する同意も含まれており、個別に同意を選択する事が出来ます。選択項目に対する同意を拒否する場合でもサービスはご利用頂けます。',
		text6: '全て同意する。',
		id: 'IDを入力してください。',
		email: 'Eメールアドレスを入力してください。',
		userName: 'ユーザー名を入力してください。',
		password: 'パスワードを入力してください。',
		rePassword: 'パスワードをもう一度入力してください。',
		show: '詳しく見る',
		agree: '同意する',
		signUp: '会員登録',
		cancel: 'キャンセル',
		confirm: '確認',
		success: '会員登録が完了しました。',
		duplicated: '重複IDです。',
		required: '（必須）',
		modal: {
			title1: 'ONETETHERサービス利用規約',
			text1: '本利用約款は、2022年3月16日から全てのユーザーに適用されます。',
			text2: 'ONETETHERへようこそ。',
			text3:
				'日本のONETETHERサービスは、国家変更法人 あるONETETHER Pte. Ltd. が提供致します。',
			text4: 'ONETETHER Pte. Ltd.は日本の金融庁に登録されています。',
			text4_1:
				'ONETETHERの金融庁登録及び日本のONETETHERサービスの詳細については、',
			text5: 'をご参照ください。',
			text6:
				'本利用約款は、日本のお客様のONETETHERアカウント及びONETETHERサービスのご利用について規定しています。',
			text7:
				'お客様が個人の場合、ONETETHERアカウントを開設してONETETHERサービスをご利用になるためには日本の居住者であり、18歳以上でなければなりません。',
			text8:
				'お客様が事業主または個人事業主である場合、ONETETHERアカウントを開設し、ONETETHERサービスをご利用になるためには、日本国内で設立及び運営されているか、日本居住者である必要があります。',
			text9:
				'ONETETHERアカウントを開設して使用することで、お客様は本利用約款のすべての規約内容を遵守することに同意します。',
			text10: 'また、お客様は以下の追加ページ、ポリシー及びお客様に適用される',
			text10_1:
				'ページに明示されたその他の各約款内容を遵守することに同意します。',
			link1: '日本のONETETHERビジネスを',
		},
	},
	'rtr_auth-dashboard': {
		text1: '人気資産',
		text2: 'お気に入り資産',
		text3: 'お気に入りウォレット/口座は最大５つ登録が可能です。',
		send: '送金',
		request: 'リクエスト',
		history: '取引履歴',
		greeting_message: '{user}様の最終訪問日時は {date}です。',
	},
	'rtr_pay-payment': {
		title1: '送金',
		title2: '送金方式',
		text1: '口座番号に出金',
		text2: 'ウォレットアドレスに出金',
		text3: 'オフラインショップ決済(モバイル専用)',
		text4: '受領口座番号',
		text5: 'ハイフン(-)を入れて入力してください。',
		text6: '受領ウォレットアドレス',
		text7: 'ウォレットアドレスを入力してください。',
		text8: '出金数量',
		text9: 'オフラインショップ決済',
		text10: '残余時間',
		text11: '決済可能時間が過ぎました。',
		text12: 'ボタンを押してください。',
		text13: 'コード再発行',
		caution: '存在しない口座番号か、有効ではない入力値です。',
		caution2: '存在しない口座番号か、有効ではない入力値です。',
		recipient: '受領人',
		askWithdraw: '出金しますか?',
		scan: 'QRスキャン',
		modal: {
			success: '送金が正常的に処理されました。',
			recipient: '受領人',
			wallet_account: 'ウォレットアドレス',
			payment_amount: '送金数量',
			check_info: '出金情報を確認してください。',
			account_number: '口座番号',
		},
	},
	'rtr_pay-deposit': {
		title1: '受け取る',
		title2: 'リクエスト方式',
		text1: '口座番号に入金',
		text2: 'ウォレットアドレスに入金',
		text3: 'インボイス',
		text4: '受領口座番号',
		text5: '受領ウォレットアドレス',
		text6: '生成されたウォレットアドレスがありません。',
		text7: 'リクエスト情報を確認してください。',
		text8: 'Eメールを入力してください。',
		text9: '品目を入力してください。',
		text10: '請求金額を入力してください。',
		my_wallet: '受領ウォレットアドレス',
		my_account: 'マイアカウント番号',
	},
	'rtr_pay-exchange': {
		title1: '両替',
		tab1: '購入',
		tab2: '売却',
		text1: '暗号資産を選択してください。',
		text2: '購入数量',
		text3: '適用数量',
		text4: '購入手数料',
		text5: '売却手数料',
		text6: '売買基準レート',
		text7: '適用為替',
		text8: '売却数量',
		text9: 'しますか？',
		text10: '購入する資産を選択してください。',
		text11: '支払する資産を選択してください。',
		text12: '売却する資産を選択してください。',
		text13: '支払を受ける資産を選択してください。',
	},
	c2c: {
		buy_list: '購買リスト',
		th1: '売却資産',
		th2: '可用数量',
		th3: '価格',
		th4: '支払資産',
		th5: '状態',
		status1: '全体',
		status4: 'キャンセル',
		OPEN: '公示中',
		CANCELED: 'キャンセル',
		COMPLETED: '完売',
		PENDING: '未確定',
		PAYED: 'ホルディング',
		REJECTED: '返戻',
		CONFIRMED: '確定',
		escrow_type: {
			BOTH: '売却公示者及び買収要請者両方が預置',
			DEALER: '売却公示者優先預置',
			APPLICANT: '買収要請者優先預置',
			DISABLE: '非活性化',
		},
		check: {
			title: '新規口座登録',
			text1: 'ウォレット/口座を追加してください。',
			text2: '生成された口座がありません。',
			text3:
				'P2Pサービスは２個以上のウォレット/口座を保有したお客様のみご利用頂けます。',
		},
		search: {
			title: '資産検索',
			head1: '全体資産',
			head2: '最近検索',
			head3: '検索結果',
			delete: '全体削除',
			empty: '検索結果なし。',
		},
		buy: {
			title: '購入申請',
			title1: '購入申請時注意事項',
			head1: '虚偽ホルディング禁止',
			head2: 'P2P取引',
			text1:
				'購入者は必ず該当P2P取引に対する支払が完了した後に‘ホルディング’をクリックしてください。',
			text2:
				'虚偽ホルディングによって発生する売却者と購入者間の紛争はONETETHERで責任を負いません。',
			text3:
				'また、虚偽ホルディングを持続的に行うとサービス利用に制限がかかるのでご注意ください。',
			text4:
				'支払いを完了した後に確定にならない場合には1:1問い合わせを通じて管理者へお問い合わせください。',
			text5:
				'外部ウォレットを通じてP2P取引をする場合には手数料が賦課されることがあり、P2P取引が正常的に成されない場合には該当取引解決に当たって不便な点があることがあります。',
			text6: 'P2P取引は売却者と購入者の自由な取引活動を基盤とします。',
			text7:
				'ONETETHERは売却者と購入者の便利で安全な取引の為のプラットフォームサービスのみを提供します。',
			text8:
				'売却者と購入者間の法的紛争が発生時にONETETHERはエスクロの役割としてのみ責任を負う点ご注意ください。',
			head3: '購入する資産',
			head4: '総売却数量',
			head5: '個当り売却価格',
			head6: '可用数量',
			head7: '保有',
			head8: '購入数量',
			head9: '手数料',
			head10: '支払する',
			head11: '数量',
			head12: '支払口座',
			text9: '手数料額',
			text10: '分だけ差し引かれます。',
		},
		sell: {
			title: '売却登録',
			title1: '売却登録時注意事項',
			head1: '虚偽公示禁止',
			head2: '確定ボタンクリック時注意事項',
			head3: '確定ボタンを押さなかった場合',
			head4: 'P2P取引',
			text1:
				'売却者必ず売却に必要な暗号資産を十分に保有した後取引をしてください。',
			text2:
				'虚偽公示を持続的に行う場合サービス利用に制限がかかることをご注意ください。',
			text3:
				'売却者は購入者の支払いを必ず確認した後に‘確定’ボタンをクリックしてください。',
			text4:
				'売却者の不注意によって発生する金銭的損害についてはONETETHERは法的に責任がありません。',
			text5: '必ず購入者の支払有無を確認してください。',
			text6:
				'売却者は購入者の支払有無を確認した後、必ず‘確定’ボタンをクリックしてください。',
			text7:
				'‘確定’ボタンをクリックしなかった場合、管理者によってサービス利用に制限がかけられることをご注意ください。',

			text8: 'P2P取引は売却者と購入者の自由な取引活動を基盤とします。',
			text9:
				'ONETETHERは売却者と購入者の便利で安全な取引の為のプラットフォームサービスだけを提供します。',
			text10:
				'売却者と購入者間の法的紛争が発生した場合ONETETHERはエスクロの役割としてのみ責任を負う点ご注意ください。',
			text11: '手数料',
			placeholder1: '売却する資産を選択してください。',
			placeholder2: '支払を受ける資産を選択してください。',
			head5: '売却数量',
			head6: '最低購入数量',
			head7: 'スプレッド比率',
			head8: '個当り売却価格',
		},
	},
	'rtr_pay-contact': {
		search: '検索',
		bookmark: 'お気に入り',
		name: '名前',
		account: '口座番号',
		memo: 'メモ',
		location: '位置',
		status: 'プロフィール',
		text1: 'すべての人がお客様のJPYS口座番号を',
		text2: '検索及び送金することができます。',
	},
	'rtr_pay-invoice': {
		title1: '請求対象',
		input1: 'Eメール',
		title2: '品目',
		input2: '商品名',
		title3: '受ける暗号資産',
		title4: '支払期日',
		title5: '総計',
		text1: 'リクエストしますか？',
	},
	'rtr_mypage-account': {
		title: 'アカウント',
		name: '名前',
		change: '名前変更',
		option: 'アカウントオプション',
		api: '販売者API',
		passport: 'パスポート',
		upgrade: 'ビジネスアカウントにアップグレード',
		email: 'Eメール',
		password: 'パスワード',
		new_password1: '新しいパスワード',
		new_password2: '新しいパスワード確認',
	},
	'rtr_mypage-data': {
		title1: 'セキュリティ',
		text1:
			'"Google Authenticator" アプリをスマートフォンまたはデスクトップにインストールしてください。',
		text2:
			'アンドロイドまたはiPhone、iPad、そしてiPod、WindowsPhone、そしてMicrosoftWindowsdesktopを含むその他',
		text3: 'のシステム。',
		text4: 'このキーを',
		text5:
			'紙に書いてください。 端末を失くしたり、OTPを変更するときに使用されます。',
		text6:
			'"Google Authenticator" アプリを起動して画面下のScanQRbarcodeをタップしてください。',
		text7:
			'端末の画面に表示された認証コードを下記の"認証コード"欄に入力してください。',
		text8: 'OTPキー',
		text10: 'OTPキー',
		text11: '(OTPを活性化するには、以下の認証番号を入力してください。)',
		text12: '認証番号を入力してください。',
		text13: 'OTPを無効にするには、以下の認証番号を入力してください。',
	},
	'rtr_wallet_account-assets': {
		title1: '資産目録',
		title2: 'ウォレット/口座',
		title3: '口座登録',
		tab1: '資産',
		tab2: 'お気に入り',
		empty: '選択された資産がありません。',
		text1: 'お気に入りのウォレット/口座は最大5つの登録が可能です。',
		text2: 'ウォレット/口座を追加してください。',
		account: '口座',
		address: 'ウォレット',
	},
	'account-wallet': {
		title1: 'マイウォレット',
		title2: 'マイアカウント',
		btn_charge: 'チャージ',
		btn_jpys_send: '送る',
		btn_other_send: '出金',
		btn_receive: '受け取る',
		text1: 'JPYSがなくてもお支払い、JANO PAYをご利用いただけます。',
		my_wallet: 'マイウォレットアドレス',
		my_account: 'マイアカウント番号',
		btn_copy: 'コピーする',
		modal: {
			title1: '電気通信、金融詐欺被害予防のための限度制限のご案内',
			text1:
				'暗号資産が非対面に開設され、ATM、インターネットによる引き出し（振替）限度があります。',
			text2: '取引目的を確認できる客観的認証資料をご提示ください。',
			text3: '「設定」で限度制限を解除することができます',
			title2: '注意事項',
			text4:
				'インターネットバンキングへの加入は入出金口座を開設した後、完了画面で連動され申請できます。',
			caution:
				'インターネットバンキングで振込をより簡単に行うためには、セキュリティ認証を受けなければなりません。認証過程で等級を向上させた後、出金限度および振替限度を引き上げてください。',
			text5:
				'新規登録ボタンをクリックすると会員固有の(暗号資産)ONETETHER専用口座および外部ウォレット連動入金アドレスが発行されます',
			text6:
				'入金前には必ずご承知おきください！ ONETETHER口座からONETETHER口座に送金すると最低取引手数料もしくは無料となります。',
			text7:
				'新規ご加入時に発行される口座/ウォレットアドレスでは(暗号資産)入金のみ可能です。当該アドレスに他のデジタル資産を入金しようとする場合に発生しうる不具合/損失は復旧不可能です。',
			text8: '1回発生すると、入金プロセスを通じて残高に反映されます。',
			text9:
				'入金プロセスは自動的に行われ、ネットワーク状況によって所要時間が異なる場合があります。上記の住所は入金専用のアドレスです。',
			text10:
				'会員様に割り当てられた新規登録では(暗号資産)を入金することができます。',
			check1: '上記の内容を理解し、同意する。',
		},
	},
	rtr_activity: {
		title: '取引履歴',
		start: '開始',
		end: '終了',
		search: '活動検索',
		button1: '明細書',
		select: '選択してください',
		text1: 'まだ取引がありません。',
		text2: '開始日と終了日を指定して再度お試しください。',
		withdrawal: '出金',
		deposit: '入金',
		type: '区分',
		registration_date: '登録日',
		asset_name: '資産名',
		sender: '送金人',
		recipient: '受領人',
		amount: '振替金額',
		w_account: '出金口座番号',
		d_account: '入金口座番号',
		w_address: '出金ウォレットアドレス',
		d_address: '入金ウォレットアドレス',
		detail: '取引内訳詳細',
		text3: '送金数量',
		text4: '入金口座番号',
		text5: '受領資産',
		text6: '受領数量',
		text7: '出金口座番号',
		text8: '送金資産',
		account: 'アカウント',
		wallet: 'ウォレット',
		check_all: '全選択',
		account_number: '口座番号',
		empty: '登録された取引履歴がありません。',
	},
	'rtr_activity-exchange': {
		title1: '両替履歴',
		tab1: '全体履歴',
		tab2: '購入履歴',
		tab3: '売却履歴',
		th1: '区分',
		th2: '登録日時',
		th3: '基準資産数量',
		th4: '適用資産数量',
		th5: '適用売買基準レート',
		th6: '適用スプレッド率',
		th7: '適用為替',
		buy: '購入',
		sell: '売却',
		empty: '登録された両替履歴がありません。',
		detail: {
			title1: '両替履歴詳細',
			th1: '購入資産',
			th2: '適用資産',
			th3: '購入資産数量',
			th5: '購入資産口座番号',
			th6: '適用資産口座番号',
			th10: '区分',
			th11: '登録日',
			th12: '売却資産',
			th13: '売却資産数量',
			th14: '売却資産口座番号',
		},
	},
	'rtr_activity-c2c': {
		title1: 'P2P履歴',
		title2: '購入履歴詳細',
		title3: '売却現況',
		title4: '販売現況詳細',
		tab1: '購入履歴',
		tab2: '売却履歴',
		purchased_asset: '購入資産',
		purchase_quantity: '購入数量',
		purchase_price: '購入価格',
		payment_asset: '支払資産',
		total_fee: '手数料合計',
		account_number: '相手口座番号',
		status: '状態',
		application_date: '申請日時',
		registration_date: '登録日時',
		closing_date: '終結日時',
		amount_paid: '支払金額',
		deposit_amount: '支払金額',
		sold_asset: '売却資産',
		sold_quantity: '売却数量',
		registered_quantity: '登録数量',
		sold_price: '売却価格',
		safety_type: '購入安全類型',
		min_purchase_quantity: '最低購入数量',
		available_quantity: '可用数量',
		confirmed_sales_quantity: '確定売却数量',
		unconfirmed_sales_quantity: '未確定売却数量',
		charge_fee: '売渡公示者賦課手数料',
		empty: '登録されたP2P購入履歴がありません。',
		empty2: '登録されたP2P売却履歴がありません。',
	},
	'rtr_activity-invoice': {
		title: 'インボイス履歴',
		target: '請求対象',
		request_asset: '要請資産',
		request_amount: '要請数量',
		item: '品目',
		due_date: '支払期日',
		empty: '登録されたインボイス履歴がありません。',
	},
	auth: {
		id: 'IDを入力してください。',
		password: 'パスワードを入力してください。',
		login_btn: 'ログイン',
		signup_btn: '会員登録',
		or: 'または',
	},
	banner1: {
		text1: 'ウォレット/口座がありませんか？',
		text2: '最も安全で即座に作れる',
		text3: 'ONETETHERのウォレット/口座を',
		text4: '今すぐ無料で作成してください。',
		text5: '今無料で作ってみてください！',
	},
	banner2: {
		text1: '受付時間',
		text2: '（24時間お問い合わせ可能）',
		text3: 'オンラインバンク',
		text4: '24時年中無休',
		text5: '（23:30-24:00利用不可）',
		text6: 'オフラインバンクの受付時間',
		text7: '（土・日・祝日除く）',
	},
	account_register: {
		title1: '電気通信、金融詐欺被害予防のための限度制限のご案内',
		text1:
			'要求払い口座が非対面で開設され、ATM、インターネットを通じた引き出し(振替)限度は1日に制限されます。',
		text2:
			'取引目的を確認できる客観的認証資料を支店に提示し、及び"管理>セキュリティ認証/管理"から限度制限を解除することができます。',
		text3:
			'インターネットバンキングを利用する際、出金口座に登録しなければ振り込み取引はできません。',
		text4: '暗号資産別限度制限口座は、1人当たり5つのみ開設できます。',
		title2: '注意事項',
		text5:
			'- インターネットバンキングへの加入は入出金口座を開設した後、完了画面で連動され申請できます。',
		text6:
			'- 現在インターネットバンキングに加入されていらっしゃる顧客は出金口座の登録区分が’インターネット+支店’になっている状態のみ、インターネットバンキングで出金口座の登録ができる事にご注意ください。',
		text7:
			'* インターネットバンキングで振込をより簡単に行うためには、セキュリティ認証を受けなければなりません。認証過程で等級を向上させた後、出金限度および振替限度を引き上げてください。',
		title3:
			'新規加入ボタンをクリックすると、会員固有の { title } ONETETHER専用口座および外部ウォレット連動入金アドレスが発行されます。',
		text8:
			'入金前に必ず知っておいてください！ ONETETHER口座から口座に送金すると最安値手数料か無料になる場合があります',
		text9:
			'新規登録時に発行される口座/ウォレットアドレスでは、{ title }の入金のみ可能です。',
		text10:
			'該当アドレスに他のデジタル資産を入金する場合に発生するエラー/損失は復旧できません。',
		text11: '1度の確認が発生して以降、入金プロセスを経て残高に反映されます。',
		text12:
			'入金プロセスは自動的に行われ、ネットワーク状況によって所要時間が異なる場合があります。 上記の住所は入金専用の住所です。',
		text13:
			'会員様に割り当てられた新規加入には{ title }を入金することができます。',
		agree: '上記の内容を理解し、同意する。',
		title4: '口座固有番号',
		title5: '口座番号',
		title6: '口座名',
		text14: '口座名を入力してください。',
		title7: '停止金額',
		title8: '状態',
		title9: '選択資産',
		text15: '自動的に入力されます。',
		title10: '生成された口座番号',
		text16: 'ONETETHER専用口座番号',
	},
	merchant: {
		picker: {
			title1: '管理する加盟店を選択してください',
			title2: '加盟店登録',
			success_shop_register: '加盟店が登録されました。',
			insert_shop_name: '加盟店名を入力してください。',
			insert_shop_id: '加盟店IDを入力してください。',
			merchant_name: '加盟店の名前',
			merchant_id: '加盟店ID',
			regist_date: '登録日',
		},
		transaction: {
			text1: '決済内訳',
			text2: '該当のお取引履歴はございません。',
			text3: '開始日と終了日を指定して、入力してください。',
			text4: '決済内訳詳細',
			empty: '登録された決済履歴がありません。',
			total_count: '総決済件',
			total_amount: '総決済金額',
			count: '件',
			table: {
				time: '決済時間',
				name: '決済名',
				id: '決済ID',
				payer: '決済者名',
				type: '決済タイプ',
				status: '状態',
				amount: '状態決済金額',
				order_no: '店の注文番号',
			},
		},
		settlement: {
			title: '精算口座管理',
			title1: '精算口座の連結',
			title2: '精算口座の連結解約',
			date: '登録日',
			asset_name: '資産名',
			account: '口座番号',
			no_content: '登録された内容がありません。',
			select: '暗号資産を選択してください。',
			name: '加盟店の名前',
			id: '加盟店ID',
			asset: '精算口座',
			connect: '精算口座の連結',
			disconnect: '解約',
			set_disconnect: '連動口座解除',
			disconnect2: '精算口座の接続が解除されました。',
		},
		title1: '取引統計',
		title2: '精算カレンダー',
		title3: 'クイックメニュー',
		title4: 'お知らせ',
		title5: 'カスタマーセンター',
		title6: '認証/管理',
		menu1: '商店情報',
		menu2: '精算口座の一覧',
		menu3: '1:1問い合わせ',
		menu4: '問い合わせ履歴',
		menu5: 'Eメール認証',
		menu6: 'OTP認証',
		menu7: '保安等級',
		menu_2: {
			menu1: 'お知らせ',
			menu2: '1:1問い合わせ',
			menu3: '問い合わせ履歴',
			menu4: 'よくあるご質問',
			menu5: 'KYC認証',
			menu6: 'Eメール認証',
			menu7: 'OTP認証',
			menu8: '出金アドレス認証',
			menu9: 'セキュリティレベル',
		},
		inquiry: {
			text1: 'お問い合わせタイプを選択してください。',
			text2: 'タイトルを入力してください。',
			text3: '内容を入力してください。',
			text4: 'お問い合わせのタイプ',
			text5: 'タイトル',
			text6: 'お問い合わせ日',
			text7: '状態',
			text8: '回答待ち',
			text9: '回答完了',
			text10: '登録された内容がありません。',
			text11: 'お問い合わせの作成内容が',
			text12: '正常に受付完了',
			text13: 'しました。',
		},
		kyc: {
			text1: '会員番号',
			text2: 'ユーザー名',
			text3: 'Eメール',
		},
		email: {
			link1: '認証コード再送信',
		},
		otp: {
			text1:
				'"Google Authenticator" アプリをスマートフォンやPCにインストールして設定してください。',
			text2:
				'アンドロイドまたはiPhone、iPad、そしてiPod、Windows Phone、そしてMicrosoft Windows desktopを含むその他のシステム。',
			text3: 'このキーを',
			text4:
				'紙に書いて安全な場所に保管しておいて下さい。端末紛失·OTPの変更の場合に必要になります。',
			text5:
				'"Google Authenticator" アプリケーションを開き、このQRコードを認証アプリで読み取ってください。',
			text6:
				'端末画面に表示される認証コードを下の”認証コード欄に入力してください。',
			text7: 'OTPキー',
			text8: 'OTPキー(OTPを有効にするため認証番号を入力してください。)',
			text9: '認証番号を入力してください。',
		},
		address: {
			select: '選択なし',
			text1: '通貨',
			text2: '資産アドレス',
			text3: '資産アドレスを入力してください。',
			text4: 'すでに認証済みの資産です。',
			text5: 'バンク選択',
			text6: '預金主名',
			text7: '口座番号',
			text8: '誕生日,',
			text9: '生年月日6桁',
			register: '登録する',
			alert: '出金住所認証が完了しました。',
		},
		security: {
			authStatus: {
				ok: '認証完了',
				no: '認証する',
			},
			level1: 'レベル1',
			level2: 'レベル2',
			level3: 'レベル3',
			level4: 'レベル4',
			email: 'Eメール認証',
			kyc: 'KYC認証',
			otp: 'OTP認証',
			address: '出金住所認証',
			title1: '会員固有番号',
			title2: 'ユーザー名',
			title3: '制限事項',
			text1: '資産1回の出金金額制限',
			text2: '100 ETH',
			text3: '資産1日の出金金額制限',
			text4: '1,000 ETH',
			text5: '資産1日の出金金額制限',
			text6: '10 BTC',
			text7: '資産1日の出金金額制限',
			text8: '1,000 BTC',
			placeholder: 'Eメールアドレスを入力してください。',
			placeholder1: '認証コードを５分以内に入力してください。',
		},
		info1: '様のセキュリティレベルは',
		info2: 'Level',
		info3: 'です。',
	},
	input: {
		placeholder: {
			search: '検索',
			select_assets: '資産を選択してください。',
			search_assets: '資産を検索してください。',
			search_activity: '活動検索',
			email: 'Eメールアドレスを入力してください。',
			code_request: '認証コードを入力してください。',
			inquiry_type: '問い合わせタイプを選択してください。',
			enter_subject: 'タイトルを入力してください。',
			inquiry_content: 'お問い合わせ内容を入力してください。',
			password: 'パスワードを入力してください。',
			all_assets: '全体資産',
		},
		label: {
			email: 'Eメール',
			password: 'パスワード',
			inquiry_type: '問い合わせタイプ',
			enter_subject: 'タイトル',
			inquiry_content: 'お問い合わせ内容',
		},
	},
	select: {
		select: '選択してください。',
		all: '全体',
	},
	button: {
		add: '追加',
		delete: '削除',
		cancel: 'キャンセル',
		change: '変更',
		pay: '支払い',
		next: '次へ',
		back: '後ろ',
		request: 'リクエスト',
		send: '送金',
		close: '閉じる',
		do_not_look: 'これ以上表示しない',
		confirm: '確認',
		signup: '会員登録',
		down: 'アプリダウンロード',
		edit: '変更',
		edit1: '編集',
		delete_account: 'アカウントを脱退する',
		code: '認証コード発送',
		code_check: '認証コード確認',
		code_completed: '認証完了',
		otp: 'OTP有効化',
		otp_disabled: 'OTP無効化',
		asset_send: '資産を送る',
		cryptocurrency_request: '暗号資産を要請する',
		membership_withdrawal: '会員脱退',
		info: '営業チームに問い合わせ',
		share: 'シェア',
		new_account: '新規加入',
		open_account: '開設',
		search: '檢索',
		start: '始まり',
		register: '登録',
		list: '目録へ',
		inquiry_list: 'お問い合わせの内訳へ',
		exchange: '両替する',
		check_balance: '残高確認',
		sales: '販売登録',
		purchase: '購入登録',
		withdraw: '出金',
		copy: 'コピーする',
		detail: '詳細',
		payment: '支払い',
		decide: '確定',
		check: 'チェック',
		reject: '拒否',
		application: '申し込み',
		connect: '連結',
		not_see_today: '今日はこれ以上表示しない',
		receive_request: '請求のリクエスト',
		block: '制限',
		more: 'もっと見る',
	},
	modal: {
		message: {
			select_asset: '資産を選択してください。',
			select_way: '出金方式を選択してください。',
			check_account: '受取人の口座を確認してください。',
			check_address: '受取人のウォレットの住所を確認してください。',
			set_amount: '振込金額を入力してください。',
			need_agree: '同意しないと新規加入できません。',
			success_exchange: '両替が正常に処理されました。',
			no_account: '登録された口座がありません。',
			set_otp: 'OTP活性化が完了しました。',
			deactivation_otp: 'OTP無効化が完了しました。',
			set_code: '認証番号を入力してください。',
			set_buy: '購入しますか？',
			registered: '登録されました。',
			set_sell: '販売しますか？',
			success_withdraw: '出金が完了しました。',
			success_confirm: '確定が正常に処理されました。',
			success_cancel: 'キャンセルが正常に処理されました。',
			success_payment: '支払いが正常に処理されました。',
			success_reject: '拒否が正常に処理されました。',
			set_cancel: 'キャンセルしますか？',
			set_pay: 'お支払いしますか？',
			set_confirm: '確定しますか？',
			set_reject: '拒否しますか?',
			sent_id: '作成されたメールにIDが発送されました。',
			sent_authCode: '作成されたメールで認証番号が発送されました。',
			pw_changed: 'パスワードが変更されました。',
			settlement_connect: '精算口座が連結されました。',
			settlement_disconnect: '精算口座を解除されますか？',
			settlement_disconnect2: '精算口座が解除されました。',
			merchant_regist_confirm: '加盟店登録が完了しました。',
			complete_payment: '決済が完了しました。',
		},
		account: {
			status1: '変更する項目を入力してください。',
			status2: 'アカウント情報が変更されました。',
			status3: '会員脱退が完了しました。',
			status4: 'アカウントを削除しますか？',
			status5: '会員名を入力してください。',
			status6: '暗証番号をご入力ください。',
			status7: '新しいパスワードを入力してください。',
			status8: '新しいパスワードの確認を入力してください。',
			status9: '新しいパスワードとパスワードの確認が一致しません。',
		},
		history: '振込内訳',
	},
	alert: {
		request_id: 'ID入力要請。',
		request_pw: 'パスワード入力要請。',
		request_check_term: '必須約款に同意してください。',
		transaction_check: '取引内訳をチェックしてください。',
		not_yet: '準備中です。',
		copy_s: 'コピーされました。',
		copy_f: 'コピーが失敗しました。',
		logout: 'ログアウトしますか？',
		enter_email: 'Eメールアドレスを入力してください。',
		enter_authCode: '認証番号を入力してください。',
		enter_newPw: '新しいパスワードを入力してください。',
		enter_newPwConfirm: '新しいパスワード確認を入力してください。',
		wrong_newInfo: '新しいパスワードとパスワード確認が一致しません。',
	},
	help: {
		title: 'ヘルプ',
		title1: '一般質問',
		q1: '活動が表示されない',
		a1: '検索記録, 訪問したウェブサイト, その他の活動が自分の活動に表示されない場合、次を確認してください。',
		q2: '確認できない活動がある',
		a2: '自分の活動に次の様に確認出来ないパターンの活動が表示されることがあります。',
		q3: '個人情報保護の為の推薦設定検討',
		a3: '自動削除オプションを設定し活動保存期間を管理することが出来ます。',
		q4: '個人情報保護設定確認',
		a4: '個人情報保護診断を通じて下に説明されているほぼ全ての設定を簡単に確認し変更することが出来ます。',
		q5: '保存する活動制御',
		a5: '活動制御設定からアカウントに保存される活動パターンを選択出来ます。次の様な活動が含まれます。',
		q6: '情報追跡及び削除',
		a6: '次のリソースは Google アカウントに保存される活動を検討し制御するのに役立ちます。',
		q7: 'データー概要確認',
		a7: "'Google ダッシュボードを訪問し、Gmail, Drive, Calendar 等 色んな Google サービスのデーターの要略を確認してみてください。",
		q8: '活動/ファイル 確認及び削除',
		a8: '次の様な関連 Google 製品で 写真, メール, 文書 等のファイルを確認し削除することができます。',
		q9: '自分の活動',
		a9: '自分の活動から検索記録及び訪問したウェブサイトの様な活動を確認し削除できます。',
		q10: '訪問した場所確認及び削除',
		a10: '位置記録を使用設定すると訪問した場所がアカウントに保存されます。自分の位置記録は自分のみ見ることが出来ます。',
		q11: '追加情報',
		a11: '次のリソースで 自分のデータと Googleで自分のデータを使用する方式を詳しく見ることが出来ます。',
		q12: '保存される活動変更',
		a12: 'この設定を変更してアカウントに保存される活動をほぼ制御することが出来ます。',
		q13: '活動確認または削除',
		a13: "'Google アカウントに移動します。",
		q14: '活動が保存される場合',
		a14: '携帯電話から Google アカウントにログインすると活動が保存されます。 活動制御が使用設定されている場合、 Googleは この設定による情報を保存することが出来ます。',
		q15: '活動削除方法',
		a15: '活動を手動で削除する、または、自動削除設定により自動で削除されると該当商品と Googleシステムからすぐに削除手続きが始まります。',
		q16: '自分の活動とは何ですか?',
		a16: '自分の活動は、自分がした検索、訪問したウェブサイト、視聴した動画などの活動を確認し管理できる場所です。',
		q17: '活動検索及び観覧',
		a17: '自分の活動は個別項目で並べられ、最新の活動から表示されます。',
		q18: '活動を削除する',
		a18: '自分の活動で過去検索記録、訪問記録及びその他活動を削除する方法を見てください。過去の活動が自動削除されるようにも設定することが出来ます。',
		q19: '管理者またはサービス提供業者のデータアクセス',
		a19: 'アカウントを通じて提出したりアップロードするデータまたはコンテンツの所有者',
		q20: 'セーフサーチ問題の解決',
		a20: 'セーフサーチが作動しない場合、セーフサーチ問題を解決する方法を見てください。',
		q21: 'アダルトコンテンツの報告',
		a21: 'セーフサーチ使用中にアダルトコンテンツを発見した場合、報告してくださるようお願いします。',
	},
	popup: {
		title1: 'クローズベータテスト',
		title2: 'JANOサポーターズ',
		title3: '募集!',
		period: 'クローズベータ期間：2022年11月23日～12月23日',
		text1: 'ONETETHERクローズベータテストにサポーターズ皆さんを招待します。',
		text2: 'ブロックチェイン基盤のPAYプラットフォーム',
		text3: 'ONETETHERを一足先に体験してみてください。',
		m_text1: 'ONETETHERクローズベータテストに',
		m_text2: '皆さんをご招待します。',
		m_text3: 'クローズベータ期間',
		m_text4: '2022年11月23日',
		m_text5: '~12月23日',
	},
	tutorial: {
		dashboard: {
			step1_title: '人気資産',
			step1_text: 'ONETETHERでお勧めする人気資産です。',
			step2_title: '送金',
			step2_text: 'ボタンをタップ(タッチ)して資産を送ってください。',
			step3_title: 'リクエスト',
			step3_text: 'ボタンをタップ(タッチ)して資産をリクエストしてください。',
			step4_title: '取引履歴',
			step4_text: '資産を送り受けた履歴を確認してください。',
			step5_title: 'お気に入りウォレット/口座',
			step5_text:
				'次のアイコンと同じボタンをタップ(タッチ)するとお気に入り資産に設定することができます。',
			step6_title: 'ウォレット/口座開設',
			step6_text: '色んな資産を追加してより多くのサービスを体験してください。',
		},
		payment: {
			step1_title: '送金する資産',
			step1_text: '送金できる資産を確認し選択してください。',
			step2_title: '送金方式',
			step2_text: '３つの方式で資産を送金できます。',
			step3_title: '1.オフラインショップ決済',
			step3_text: 'ONETETHER加盟店にてQRコードで手軽に決済できます。',
			step4_title: '2.口座番号に出金',
			step4_text: 'ONETETHERユーザーに口座番号で資産を送金できます。',
			step5_title: '3.ウォレットアドレスに出金',
			step5_text: 'ウォレットアドレスにJPYSと暗号資産を送金できます。',
		},
		deposit: {
			step1_title: 'リクエストする資産',
			step1_text: 'リクエストできる資産を確認して選択してください。',
			step2_title: 'リクエスト方式',
			step2_text: '３つの方式で資産をリクエストできます。',
			step3_title: '1.口座番号に入金',
			step3_text: 'ONETETHERユーザーに口座番号で資産をリクエストできます。',
			step4_title: '2.ウォレットアドレスに入金',
			step4_text: 'ウォレットアドレスに資産をリクエストできます。',
			step5_title: '3.インボイス',
			step5_text: '請求書を送って資産をリクエストできます。',
		},
		exchange: {
			step1_title: '購入/売却',
			step1_text: 'ONETETHERが提案する両替方式で資産を両替してみてください。',
		},
		c2c: {
			step1_title: '売却登録',
			step1_text:
				'他のONETETHERユーザーに自分が保有している資産を売却できます。',
			step2_title: 'リスト更新',
			step2_text:
				'アイコンボタンをタップ(タッチ)して現在販売中の全てのリストを確認してください。',
			step3_title: '購入申請',
			step3_text: '購入したい販売件を選択して購入を申請できます。 ',
		},
	},
	underConstruction: '今は準備中です。 早い時間内にお見せします。',
	menu: {
		dashboard: 'ダッシュボード',
		personal: '個人',
		'personal-how': 'ショッピング・購入方法',
		'personal-how-online_shopping': 'オンラインショッピング',
		'personal-how-offline_kiosk': 'オフラインキオスク',
		'personal-how-qr': 'QRコード決済',
		'personal-how-janopay_creditcard': 'ONETETHER クレジットカード',
		'personal-how-trade_and_cashback': '取引・ キャッシュバック',
		'personal-request': '送る・受け取る',
		'personal-request-send': '資産の送付',
		'personal-request-receive': '入金リクエスト',
		'personal-request-deposit': '入金を受け取る',
		'personal-request-commission': '手数料',
		'personal-asset': '残高管理',
		'personal-asset-wallet': 'ウォレット',
		'personal-asset-account': '口座',
		'personal-asset-jpys': 'JPYS追加',
		'personal-asset-sale': '販売',
		'personal-asset-exchange': '両替',
		business: 'ビジネス',
		'business-how': '初めての方へ',
		'business-how-start': '初めての方へ  ',
		'business-how-solution': 'ソリューション',
		'business-how-receive': '支払い承認 ',
		'business-how-pay': 'お支払い',
		'business-how-risk': 'リスクマネジメント',
		'business-operation': '運営方法',
		'business-operation-corps': '企業について',
		'business-operation-platform': 'フラットフォーム・機能',
		'business-operation-pay': 'お支払い方法',
		'business-operation-global': 'グローバル支払い',
		'business-asset': '資産管理',
		'business-asset-pay': 'お支払方法',
		'merchant-console-catalog': 'ショップ情報',
		'merchant-console-transaction-list': '決済履歴',
		'merchant-console-settlement_account': '精算口座リスト',
		'merchant-console-cs-notice': 'カスタマーセンター',
		'merchant-console-certification-kyc': '認証/管理',
		development: '開発',
		cs: 'カスタマーセンター',
		notice: 'お知らせ',
		inquiry: '1:1問い合わせ',
		inquiry_detail: '問い合わせ履歴',
		faq: 'よくあるご質問',
		pay: '資金管理',
		'pay-payment': '送金',
		'pay-deposit': 'リクエスト',
		'pay-exchange': '両替',
		'pay-c2c': 'P2P',
		'pay-contacts': '連絡先',
		'pay-invoice': 'インボイス',
		wallet_account: 'ウォレット／口座',
		'wallet_account-wallet': 'ウォレット',
		'wallet_account-account': '口座',
		'wallet_account-assets': '全資産',
		activity: '活動履歴',
		'activity-transaction': '取引履歴',
		'activity-exchange': '両替履歴',
		'activity-c2c': 'P2P履歴',
		'activity-invoice': 'インボイス履歴',
		help: 'ヘルプ',
		setting: '設定',
		'setting-security': 'セキュリティ',
		'setting-payment': 'お支払い',
		'setting-notice': 'お知らせ',
		mypage: 'マイページ',
		merchant: {
			merchant: '加盟店',
			personal: '個人',
			information: '加盟店情報',
			payment_history: '決済内訳',
		},
		'mypage-account': 'アカウント',
		'mypage-data': 'データ',
		'mypage-certification': '認証/管理',
		'mypage-seller_tool': '販売者向けツール',
		logout: 'ログアウト',
		login_text1: 'ログインして',
		login_text2: 'もっと多い情報を確めてください。',
	},
	merchant_management: {
		menu: 'メニュー',
		title: {
			qr_payment: 'QRスキャン',
			payment_list: '決済内訳',
			merchant_management: '加盟店管理',
			account: 'アカウント',
			setup: '設定',
		},
		merchant_list: '様の加盟店リスト',
		account_number: '口座番号',
		qr_payment: {
			deal_name: '取引名',
			title: 'QR決済',
			payer: '決済者',
			check_payment_information: '決済情報を確認してください。',
			payment: '決済',
			complete_payment: '決済が完了しました。',
			payment_asset: '決済資産',
			payment_name: '決済内容',
			amount: '決済金額',
		},
		payment_list: {
			login: 'ログイン',
			forgot: 'ID/パスワードを探す',
			qr_scan: 'QRコードをスキャンしてください。',
			merchant_selection: '加盟店 選択',
			count: '件',
			order_number: '注文番号',
			detail: {
				total_payment: '総 決済件',
				total_amount: '総決済金額',
				complete_payment: '決済完了',
				refund: '払い戻し',
				no_payment_count: '該当日付の決済件がありません。',
				merchant_name: '加盟店名',
				payment_assets: '決済資産',
				payment_date: '決済日時',
				refund_date: '払い戻し日時',
				check_refund_information: '払い戻し情報を確認してください。',
				refund_complete: '払い戻しが完了しました。',
			},
			table: {
				time: '決済時間',
				name: '決済名',
				id: '決済ID',
				payer: '決済者名',
				type: '決済タイプ',
				status: '状態',
				amount: '状態決済金額',
				oder_no: '店の注文番号',
			},
			modal: {
				title: '詳細照会',
				date1: '今日',
				date2: '昨日',
				date3: '1ヶ月',
				date4: '3ヶ月',
				date5: '6ヶ月',
			},
		},
		setup: {
			language: '言語',
			terms: '約款',
			push_notification: 'プッシュ通知',
		},
	},
};
